import LineIcon from "@assets/icons/line.svg";
import styled from "@emotion/styled";
import { Delay } from "components/atoms/Delay";
import { fortuneTellerIcon } from "components/templates/無料占いBot";
import dayjs from "dayjs";
import { Balloon } from "features/無料占いBot/components/Balloon";
import { useRouter } from "next/router";
import { useFormContext } from "react-hook-form";
import { ArrowIcon } from "shared/assets/icons/ArrowIcon";
import { Avatar } from "shared/components/atoms/Avatar";
import { Button } from "shared/components/atoms/Button";
import { Image } from "shared/components/atoms/Image";
import { eventName, eventAction, useGaEvent } from "shared/hooks/useGaEvent";
import { css } from "twin.macro";

const Stripe = styled.div`
  width: 100%;

  &:before,
  &:after {
    display: block;
    content: "";
    width: 100%;
    height: 20px;
    background-image: linear-gradient(90deg, #516378 60%, #fff 40%);
    background-size: 40px 39px;
    background-repeat: repeat;
  }
`;

const LineButton = ({
  className,
  onClick,
}: {
  className?: string;
  onClick: () => void;
}) => {
  const { query } = useRouter();
  const action = query.action as string;

  return (
    <Button
      type="submit"
      tw="px-3 mt-4 bg-gradient-twilight-to-r rounded-[10px] h-[52.5px]"
      className={className}
      onClick={onClick}
    >
      {action === "line" && <LineIcon tw="mr-1" />}
      <span tw="text-sm font-semibold align-middle">
        今すぐ無料で結果を見る
      </span>
      <ArrowIcon
        tw="ml-1 svg text-white"
        css={css({ transform: "rotate(180deg)" })}
      />
    </Button>
  );
};

const Result = () => {
  const { sendEvent } = useGaEvent();
  const { watch } = useFormContext();

  const [themeId, answerId] = watch(["theme", "answer"]);

  const handleClickButton1 = () => {
    sendEvent({
      eventName: eventName.freeFortuneChatBot,
      eventAction: eventAction.freeFortuneChatBot.clickRegistrationButton01,
      eventParams: {
        theme_id: themeId,
        answer_id: answerId,
      },
    });
  };

  const handleClickButton2 = () => {
    sendEvent({
      eventName: eventName.freeFortuneChatBot,
      eventAction: eventAction.freeFortuneChatBot.clickRegistrationButton02,
      eventParams: {
        theme_id: themeId,
        answer_id: answerId,
      },
    });
  };

  return (
    <Delay icon={fortuneTellerIcon}>
      <Balloon icon={fortuneTellerIcon}>
        {`ご回答ありがとうございます！🙋‍♀️\nそれでは頂いた情報を元に鑑定結果が出力されますので少々お待ちください。\n\nお待ちの間にここでCMです🙇‍♂️\n現在虹子が活動しているインターネット占い館MIRORをyoutuberの方に紹介して頂いております😍\n\nこちらの鑑定は無料鑑定となりますが、申し込み頂いた本鑑定では今回の鑑定よりも更に詳しく&細かく、実際に対面で鑑定しているかのように皆様のお手伝いをさせて頂いております😌\n\n是非こちらをお待ちの間にご覧くださいませ。\n※鑑定結果出力 予想待ち時間 45秒~1分`}
      </Balloon>
      <Stripe tw="mt-[30px]">
        <video
          src={`${process.env.NEXT_PUBLIC_CDN_V2}/無料占い/promotion_naporitan.mp4`}
          autoPlay
          controls
          muted
          tw="w-full"
        />
      </Stripe>
      <Delay icon={fortuneTellerIcon} delay={10_000}>
        <Balloon icon={fortuneTellerIcon}>
          {`大変お待たせいたしました。\n\nご記入いただいた情報、お悩みについて占い鑑定が完了いたしました🔮\n\n下記の【今すぐ無料で結果を見る】を選択し、鑑定結果をご確認ください🌙`}

          <LineButton tw="w-full" onClick={handleClickButton1} />
        </Balloon>
        <div tw="items-end w-11/12 flex">
          <Avatar src={fortuneTellerIcon} tw="mr-2" />
          <div tw="flex-col w-full flex">
            <div tw="mb-2 w-full relative flex-center">
              <Image
                src={`${process.env.NEXT_PUBLIC_CDN_V2}/無料占い/blurred_chat.png`}
                width={259}
                height={1158}
                layout="responsive"
                unoptimized
                tw="w-full mt-[30px]"
              />
              <LineButton tw="absolute" onClick={handleClickButton2} />
            </div>
            <span tw="ml-1 text-2xs font-normal color[#838D9B]">
              {dayjs().format("YYYY/MM/DD HH:mm")}
            </span>
          </div>
        </div>
      </Delay>
    </Delay>
  );
};

export default Result;
